import React, {Component} from 'react';
import {Toast} from 'antd-mobile';
import './style.less';
import {connect} from "react-redux";

@connect(
    state => ({userInfo: state.userInfo}),
)
export default class Statistics extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }

    componentDidMount() {

    }

   

    render() {
        let {totalData} = this.props;
        return (
            <div className="today">
                <div className="header">
                    <div className="totalAmount" style={{position:'absolute'}}>
                        <div className="interCity">
                            <div>预约出行</div>
                            <span>单位：元</span>
                        </div>
                        <div className="totalPrice">￥{totalData.interCityOrderBill ? totalData.interCityOrderBill.totalPrice : 0}</div>
                        <div className="complete">
                            <div>已完成行程：<span>{totalData.interCityOrderBill ? totalData.interCityOrderBill.serviceCount : 0} 趟</span></div>
                            <div>服务人数：<span>{totalData.interCityOrderBill ? totalData.interCityOrderBill.servicePeopleCount : 0} 人</span></div>
                        </div>
                    </div>
                </div>
                <div className="totalAmount" id="second">
                    <div className="interCity">
                        <div>城内约车</div>
                        <span>单位：元</span>
                    </div>
                    <div className="totalPrice">¥{totalData.cityOrderBill ? totalData.cityOrderBill.totalPrice : 0}</div>
                    <div className="complete">
                        <div>累计接单：<span>{totalData.cityOrderBill ? totalData.cityOrderBill.serviceCount : 0} 次</span></div>
                    </div>
                </div>
                <div className="totalAmount">
                    <div className="interCity">
                        <div>分流专车</div>
                        <span>单位：元</span>
                    </div>
                    <div className="totalPrice">¥{totalData.shuntOrderConbinationBill ? totalData.shuntOrderConbinationBill.totalPrice : 0}</div>
                    <div className="complete">
                        <div>累计接单：<span>{totalData.shuntOrderConbinationBill ? totalData.shuntOrderConbinationBill.serviceCount : 0} 次</span></div>
                    </div>
                </div>
                
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Statistics/index.js